var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { memo, useCallback, useMemo } from 'react';
import { useMapContext } from '../../hooks';
import { ZOOM_ANIMATION } from '../animation';
import MinusIcon from './MinusIcon';
import PlusIcon from './PlusIcon';
import { container, zoomIn, zoomOut } from './styles';
var ZoomControl = function (_a) {
    var _b = _a.animation, animation = _b === void 0 ? ZOOM_ANIMATION : _b, style = _a.style, onClick = _a.onClick;
    var map = useMapContext();
    /**
     * https://github.yandex-team.ru/mapsapi/jsapi-v2/blob/814c6f43927d177826a59d24b1e9241567a5626f/src/control/zoom/zoom-control.js
     */
    var zoomInHandler = useCallback(function (e) {
        if (onClick) {
            onClick(e);
        }
        return map.setZoom(map.getZoom() + 1, animation);
    }, [onClick, map, animation]);
    var zoomOutHandler = useCallback(function (e) {
        if (onClick) {
            onClick(e);
        }
        return map.setZoom(map.getZoom() - 1, animation);
    }, [onClick, map, animation]);
    var commonStyle = useMemo(function () { return (__assign(__assign({}, container), style)); }, [style]);
    return (React.createElement("div", { style: commonStyle },
        React.createElement("button", { type: "button", style: zoomIn, onClick: zoomInHandler },
            React.createElement(PlusIcon, null)),
        React.createElement("button", { type: "button", style: zoomOut, onClick: zoomOutHandler },
            React.createElement(MinusIcon, null))));
};
export default memo(ZoomControl);
